<template>
  <div class="task-bubbles">
    <div class="d-flex flex-row gap-1">
      <div class="task-bubble success"
           v-if="getTasksNotStarted(tasks) > 0">
        {{ getTasksNotStarted(tasks) }}
      </div>
      <div class="task-bubble danger"
           v-b-tooltip.hover
           :title="$t('overdue')"
           v-if="getTasksPassed(tasks) > 0">
        {{ getTasksPassed(tasks) }}
      </div>
      <div class="task-bubble danger"
           v-if="getNoTasks(tasks)">0</div>
      <div class="task-bubble warning"
           v-b-tooltip.hover
           :title="$t('in_process')"
           v-if="getTasksInProcess(tasks) > 0">
        {{ getTasksInProcess(tasks) }}
      </div>
    </div>
  </div>
</template>

<script setup>
import moment from 'moment/moment'

defineProps({
  tasks: Array
})

const getTasksNotStarted = (tasks) => {
  return tasks.filter(task => !task.finished && task.start > moment().format('YYYY-MM-DD HH:mm:ss')).length
}

const getTasksPassed = (tasks) => {
  return tasks.filter(task => !task.finished && task.deadline < moment().format('YYYY-MM-DD HH:mm:ss')).length
}

const getNoTasks = (tasks) => {
  return tasks.length === 0 || (tasks.length > 0 && tasks.every(task => task.finished))
}

const getTasksInProcess = (tasks) => {
  // return tasks.filter(task => !task.finished && ['inprogress', 'planned'].includes(task.status)).length
  return tasks.filter(task => !task.finished && (
      ['inprogress'].includes(task.status) || (task.deadline > moment().format('YYYY-MM-DD HH:mm:ss') && !task.start)
  )).length
}
</script>
